import { useState } from "react";
import CreateNewDefinitionLookupFields from "./CreateNewDefinitionLookupFields";
import CreateNewDefinitionRowFiltering from "./CreateNewDefinitionRowFiltering";
import { useSelector } from "react-redux";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

const CreateNewDefinition = () => {
  const { loading } = useSelector((state: any) => state.uniqueDefinition);
  const [showLookupFields, setShowLookupFields] = useState(false);

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <>
            <CreateNewDefinitionRowFiltering
              setShowLookupFields={setShowLookupFields}
            />
            {showLookupFields && <CreateNewDefinitionLookupFields />}
          </>
          {/* <Typography
            variant="body2"
            sx={{ mt: 3, textAlign: "center", color: "#888" }}
          >
            No data found for the selected interface and destination table.
          </Typography> */}
        </>
      )}
    </>
  );
};

export default CreateNewDefinition;
